import { useState } from 'react';

export const PLACEHOLDER = '/item-placeholder.svg';

/** The restaurant's own photo, or a neutral KhataRasoi tile when there is none (never a stock food image). */
export function ItemImage({ src, large = false }: { src: string | null; large?: boolean }) {
  const [failed, setFailed] = useState(false);
  const photo = src && !failed ? src : null;
  return (
    <img
      className={`${large ? 'item-image-large' : 'item-image'}${photo ? '' : ' placeholder'}`}
      src={photo ?? PLACEHOLDER}
      alt=""
      loading="lazy"
      data-testid={photo ? 'item-photo' : 'item-placeholder'}
      onError={() => setFailed(true)}
    />
  );
}
